import { BaseService } from './baseService';
import { RehabFacilityDto, RehabFacilityFormData } from '../types/rehabFacility';

class RehabFacilityService extends BaseService<RehabFacilityDto, RehabFacilityFormData> {
    constructor() {
        super('/RehabFacility');
    }
}

export const rehabFacilityService = new RehabFacilityService();